/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-south-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://3b4pap2mqa.execute-api.ap-south-1.amazonaws.com/dev",
            "region": "ap-south-1"
        },
        {
            "name": "waba",
            "endpoint": "https://v62nwm1aci.execute-api.ap-south-1.amazonaws.com/dev",
            "region": "ap-south-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://xea6merngnbyrm64jfzs346ukm.appsync-api.ap-south-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-south-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "ap-south-1:69b3337a-4879-4032-95e6-9ecde3508982",
    "aws_cognito_region": "ap-south-1",
    "aws_user_pools_id": "ap-south-1_r8y2nyoF9",
    "aws_user_pools_web_client_id": "52qq87356vp1otdh964m5qtvpq",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "PHONE_NUMBER"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "PHONE_NUMBER"
    ],
    "aws_user_files_s3_bucket": "superfone-user-content230606-dev",
    "aws_user_files_s3_bucket_region": "ap-south-1",
    "predictions": {
        "identify": {
            "identifyEntities": {
                "proxy": false,
                "region": "ap-south-1",
                "celebrityDetectionEnabled": true
            }
        }
    }
};


export default awsmobile;
